type OfficialWordmarkProps = {
  className?: string;
  dark?: boolean;
};

/** The text-only WakaSkul wordmark; the emblem remains available separately as the favicon. */
export function OfficialWordmark({ className = "", dark = false }: OfficialWordmarkProps) {
  return (
    <img
      src={dark ? "/brand/wakaskul-wordmark-only-dark.png" : "/brand/wakaskul-wordmark-only.png"}
      alt="Wakaskul"
      className={`h-7 w-auto object-contain ${className}`}
    />
  );
}
